import { useRef, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

// 传送门构造器
const ClientOnlyPortal = ({ children }: {
  children: React.ReactNode
}) =>{
  const ref = useRef<HTMLDivElement>()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    // 获取传送门挂载点
    if (ref.current) {
      // discard
    } else {
      const div = document.createElement('div')
      div.dataset.name = 'client-only'
      document.body.appendChild(div)
      ref.current = div
    }
    setMounted(true)
  }, [])

  return (mounted && ref.current)
    ? createPortal(children, ref.current)
    : null
}

export default ClientOnlyPortal;